import React from 'react';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import { MdAdd } from 'react-icons/md';
import withStyles from '@material-ui/core/styles/withStyles';
import MaterialTable from 'material-table';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import ModalRoot from 'components/Modal/ModalRoot';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';

import Fab from '@material-ui/core/Fab';
import { Edit, Delete } from '@material-ui/icons';

import Media from '../../Template/components/Media';
import { RenderIconButton } from '../../Channel/shared/components/GenericComponents';

const styles = theme => ({
  paper: {
    padding: theme.spacing(3),
    color: theme.palette.text.secondary,
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  card: {
    width: 'auto',
    margin: '10px',
    display: 'inline-block',
  },
  orderIcons: {
    display: 'flex',
  },
  renderIcon: {
    margin: 0,
  },
});

const tableSize = {
  cellStyle: { padding: '4px 15px 4px 15px' },
  headerStyle: { padding: '4px 15px 4px 15px' },
};

class Sports extends React.Component {
  state = {
    logApi: null,
    dialogType: '',
    sportName: '',
    image: '',
    imageUrl: '',
    selectedSport: '',
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  cleanForm = () => {
    this.setState({
      sportName: '',
      image: '',
      imageUrl: '',
      selectedSport: '',
    });
  };

  fillDialogForm = row => {
    this.setState({
      sportName: row.name,
      imageUrl: row.logo
        ? `https://${row.logo.container}.s3.amazonaws.com/${row.logo.blob}`
        : '',
      selectedSport: row._id,
      dialogType: 'edit',
    });
  };

  updateImageToSend = (image, imageUrl) => {
    this.setState({ image: image, imageUrl: imageUrl });
  };

  render() {
    const {
      classes,
      auth,
      sports,
      subscribe,
      refreshSports,
      createSport,
      editSport,
      confirmDeleteSport,
      alertOpen,
      dialogOpen,
      changeDialogState,
      changeAlertState,
      errorMessage,
      updateErrorMessage,
    } = this.props;

    const mediaContainer = {
      backgroundImage: `url("./images/${this.state.imageUrl}")`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Fab
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            onClick={() => {
              this.handleChange('dialogType', 'create');
              changeDialogState(true);
            }}
            style={{
              marginBottom: '20px',
              paddingRight: '15px',
              outline: 'none',
            }}
          >
            <MdAdd
              style={{
                fontSize: '30px',
                paddingRight: '5px',
                fontWeight: 'bold',
              }}
            />
            Add new Sport
          </Fab>
        </div>

        <MaterialTable
          elevation={0}
          xs={12}
          options={{
            pageSizeOptions: [5, 10, 20],
            toolbar: true,
            paging: true,
            emptyRowsWhenPaging: false,
            search: true,
          }}
          columns={[
            /*{
              ...tableSize,
              title: 'Order',
              field: 'order',

              render: rowData => {
                return (
                  <div className={classes.orderIcons}>
                    <RenderIconButton
                      clickEvent={() => {
                        editSport(rowData._id, {
                          order: rowData.order - 1,
                        });
                      }}
                      title={'Move up'}
                      placement={'top'}
                      icon={<ArrowUpward fontSize={'small'} />}
                      color={'primary'}
                    />

                    <RenderIconButton
                      clickEvent={() => {
                        editSport(rowData._id, {
                          order: rowData.order + 1,
                        });
                      }}
                      title={'Move down'}
                      placement={'top'}
                      icon={<ArrowDownward fontSize={'small'} />}
                      color={'primary'}
                    />
                  </div>
                );
              },
              defaultSort: 'asc',
            },*/
            {
              ...tableSize,
              title: 'Name',
              field: 'name',
              customSort: (a, b) =>
                a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            },
            {
              ...tableSize,
              title: 'Logo',
              field: 'logo',
              render: rowData => {
                return (
                  <React.Fragment>
                    {rowData.logo ? (
                      <Card className={classes.card}>
                        <CardMedia
                          style={{
                            backgroundImage: `url(https://${rowData.logo.container}.s3.amazonaws.com/${rowData.logo.blob})`,
                            backgroundSize: 'contain',
                            padding: '20px',
                            border: '1px solid rgba(255, 255, 255, 1)',
                            width: '100px',
                            height: '100px',
                          }}
                          image={`url(https://${rowData.logo.container}.s3.amazonaws.com/${rowData.logo.blob})`}
                        />
                      </Card>
                    ) : (
                      'None Selected'
                    )}
                  </React.Fragment>
                );
              },
              sorting: false,
            },
            {
              ...tableSize,
              title: 'Active',
              field: 'active',
              render: rowData => (
                <div>
                  <Switch
                    color="primary"
                    checked={Boolean(rowData.active)}
                    onChange={() => {
                      if (rowData.hasEvent) {
                        changeAlertState(true);
                      } else {
                        editSport(rowData._id, { active: !rowData.active });
                      }
                    }}
                  />
                </div>
              ),
              sorting: false,
            },
            {
              ...tableSize,
              title: 'Options',
              render: rowData => (
                <div>
                  <React.Fragment>
                    <RenderIconButton
                      disabled={rowData.hasDependencies}
                      clickEvent={() => {
                        confirmDeleteSport(rowData);
                      }}
                      title={'Delete Sport'}
                      placement={'top'}
                      icon={<Delete />}
                      color={'primary'}
                    />

                    <RenderIconButton
                      clickEvent={() => {
                        this.fillDialogForm(rowData);
                        changeDialogState(true);
                      }}
                      title={'Edit Sport'}
                      placement={'top'}
                      icon={<Edit />}
                      color={'primary'}
                    />
                  </React.Fragment>
                </div>
              ),
              sorting: false,
            },
          ]}
          data={sports}
          title={"Sport's"}
          actions={[
            {
              icon: 'refresh',
              tooltip: 'Refresh Data',
              isFreeAction: true,
              onClick: () => refreshSports(),
            },
          ]}
        />

        <Dialog
          open={alertOpen}
          onClose={() => {
            changeAlertState(false);
          }}
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
        >
          <DialogTitle id="scroll-dialog-title">
            You cannot disable this Sport.
          </DialogTitle>
          <DialogContent dividers>
            <div
              style={{
                float: 'right',
                flexGrow: 1,
                flexWrap: 'wrap',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
              }}
            >
              <Typography variant="subtitle2" gutterBottom align="center">
                This sports has dependent leagues, games or players.
              </Typography>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              color="primary"
              onClick={() => {
                changeAlertState(false);
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={dialogOpen}
          onClose={() => {
            changeDialogState(false);
            this.cleanForm();
          }}
          fullWidth={true}
          maxWidth="sm"
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
        >
          <DialogTitle id="scroll-dialog-title">
            {this.state.dialogType === 'edit' ? 'Edit Sport' : 'Add Sport'}
          </DialogTitle>
          <DialogContent dividers>
            <div
              style={{
                float: 'left',
                display: 'flex',
                flexWrap: 'wrap',
                flexGrow: 1,
                flexDirection: 'column',
                width: '50%',
              }}
            >
              <TextField
                style={{ marginBottom: '20px' }}
                {...(errorMessage !== ''
                  ? { error: true, helperText: `${errorMessage}` }
                  : {})}
                id="standard-full-width"
                label="Sport Name"
                name="name"
                placeholder="Enter Sport name"
                inputProps={{ maxLength: 100 }}
                value={this.state.sportName}
                onChange={event => {
                  this.handleChange('sportName', event.target.value);
                }}
                required
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div
              style={{
                float: 'right',
                flexGrow: 1,
                flexWrap: 'wrap',
                display: 'flex',
                flexDirection: 'column',
                width: '50%',
              }}
            >
              <Typography variant="subtitle2" gutterBottom align="center">
                Sport Logo
              </Typography>
              <div
                className={
                  this.state.imageUrl !== ''
                    ? (mediaContainer, ' icon-container media-container')
                    : 'icon-container media-container'
                }
                style={{
                  width: 200,
                  height: 200,
                  boxSizing: 'border-box',
                  margin: '0 auto',
                }}
              >
                <Media
                  size={200}
                  auth={auth}
                  mediaType="image"
                  mediaFile={this.state.image}
                  mediaUrl={this.state.imageUrl}
                  onChange={this.updateImageToSend}
                  onFetch={this.updateImageToSend}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                changeDialogState(false);
                this.cleanForm();
              }}
              color="primary"
            >
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => {
                const state = this.state;

                if (state.sportName && state.sportName !== '') {
                  const newSport = {
                    name: state.sportName,
                    image: state.image,
                  };

                  if (state.dialogType === 'edit') {
                    editSport(state.selectedSport, newSport);
                  } else {
                    createSport(newSport);
                  }

                  this.cleanForm();
                  changeDialogState(false);
                } else {
                  updateErrorMessage('Sport name has to be filled');
                }
              }}
              disabled={'selectedElement' === 'undefined'}
            >
              Save Sport
            </Button>
          </DialogActions>
        </Dialog>
        <ModalRoot />
      </div>
    );
  }
}

export default withStyles(styles)(Sports);
